<div class="rs-card">
  <div class="head">
    <div class="title">Stick Tuning</div>
  </div>

  <div class="body">
    <p class="description">
      Deadzone ignores small stick movements near centre (values above it are rescaled smoothly from 0 to full
      deflection). Expo softens the response near centre for finer control while keeping full deflection at the edges.
    </p>

    <div class="tuning-rows">
      <div class="tuning-row header-row">
        <span class="axis-label"></span>
        <span class="col-heading">Deadzone</span>
        <span class="col-heading">Expo</span>
      </div>

      <div class="tuning-row" *ngFor="let row of rows; trackBy: trackByType">
        <label class="axis-label">{{ row.label }}</label>

        <div class="control">
          <mat-slider class="axis-slider" [min]="deadzoneMin" [max]="deadzoneMax" [step]="deadzoneStep"
            ><input matSliderThumb [ngModel]="row.deadzone" (ngModelChange)="onDeadzoneChange(row.type, $event)"
          /></mat-slider>

          <app-mat-form-field class="axis-input" appearance="outline">
            <input
              appMatInput
              type="number"
              [attr.aria-label]="row.label + ' deadzone'"
              [min]="deadzoneMin"
              [max]="deadzoneMax"
              [step]="deadzoneStep"
              [ngModel]="row.deadzone"
              (ngModelChange)="onDeadzoneChange(row.type, $event)"
            />
          </app-mat-form-field>
        </div>

        <div class="control">
          <mat-slider class="axis-slider" [min]="expoMin" [max]="expoMax" [step]="expoStep"
            ><input matSliderThumb [ngModel]="row.expo" (ngModelChange)="onExpoChange(row.type, $event)"
          /></mat-slider>

          <app-mat-form-field class="axis-input" appearance="outline">
            <input
              appMatInput
              type="number"
              [attr.aria-label]="row.label + ' expo'"
              [min]="expoMin"
              [max]="expoMax"
              [step]="expoStep"
              [ngModel]="row.expo"
              (ngModelChange)="onExpoChange(row.type, $event)"
            />
          </app-mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
